import(/* webpackMode: "eager" */ "/var/www/lumi/apps/teacher/src/app/global-error.tsx");
